export const init = () => { // eslint-disable-line import/prefer-default-export
  scrollBlogMeta();
};

export const scrollBlogMeta = () => {
  const blogMeta = document.getElementsByClassName('blog-meta')[0];
  if (!blogMeta) {
    return false;
  }

  const blogMetaHeight = blogMeta.offsetHeight;
  if (window.innerHeight < blogMetaHeight) {
    blogMeta.classList.remove('blog-meta--sticky');
    return false;
  }

  blogMeta.classList.add('blog-meta--sticky');

  return blogMeta;
};



// WEBPACK FOOTER //
// ./src/assets/js/blog.js